import React from 'react';
import Fade from 'react-reveal/Fade';
import { InputText, InputFile } from 'elements/Form';

export default function Payment(props) {
  const { data, ItemDetails, checkout } = props;
  const tax = 10;
  const discount = 0;
  const subTotal = ItemDetails.price * checkout.duration;
  const taxAmount = (subTotal * tax) / 100;
  const grandTotal = subTotal + taxAmount - discount;

  // Deteksi ukuran layar
  const isMobile = window.innerWidth <= 768;

  return (
    <Fade>
      <div className="container" style={{ marginBottom: 30 }}>
        <div className="row justify-content-center align-items-center">
          {/* Kolom kiri */}
          <div
            className="col-12 col-md-5 border-md-right py-5"
            style={{
              paddingRight: isMobile ? 0 : 80,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <Fade delay={300}>
              <p className="mb-4 fw-bold">Transfer Pembayaran:</p>
              <p>Sub Total: Rp. {new Intl.NumberFormat("id-ID").format(subTotal)}</p>
              <p>Tax ({tax}%): Rp. {new Intl.NumberFormat("id-ID").format(taxAmount)}</p>
              <p>Total: Rp. {new Intl.NumberFormat("id-ID").format(grandTotal)}</p>

              <div className="row mt-4 justify-content-center justify-content-md-start">
                <div className="col-6 col-md-4 mb-3 mb-md-0 text-center">
                  <img
                    src={
                      ItemDetails.bank[0].imageUrl
                        ? `${process.env.REACT_APP_HOST}/images/${ItemDetails.bank[0].imageUrl}`
                        : ""
                    }
                    alt={ItemDetails.bank[0].nameBank}
                    width="100"
                  />
                </div>
                <div className="col-12 col-md-6 text-center text-md-start">
                  <dl>
                    <dd>{ItemDetails.bank[0].nameBank}</dd>
                    <dd>{ItemDetails.bank[0].nomorRekening}</dd>
                    <dd>{ItemDetails.bank[0].name}</dd>
                  </dl>
                </div>
              </div>
            </Fade>
          </div>

          {/* Kolom kanan */}
          <div
            className="col-12 col-md-5 py-5"
            style={{
              paddingLeft: isMobile ? 0 : 80,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <Fade delay={600}>
              <label htmlFor="proofPayment">Upload Bukti Transfer</label>
              <InputFile
                accept="image/*"
                id="proofPayment"
                name="proofPayment"
                value={data.proofPayment}
                onChange={props.onChange}
              />

              <label htmlFor="bankName" className="mt-3">Asal Bank</label>
              <InputText
                id="bankName"
                name="bankName"
                type="text"
                value={data.bankName}
                onChange={props.onChange}
              />

              <label htmlFor="bankHolder" className="mt-3">Nama Pengirim</label>
              <InputText
                id="bankHolder"
                name="bankHolder"
                type="text"
                value={data.bankHolder}
                onChange={props.onChange}
              />
            </Fade>
          </div>
        </div>
      </div>
    </Fade>
  );
}
